import React from "react";

import { IconButton, MenuItem, Popover, Divider, Box } from "@mui/material";

import { MoreVert } from "@mui/icons-material";

import { SidebarEnum } from "./types";

import "./extension-styles.css";
import "./simple-editor.scss";

interface ActionButtonProps {
  activeSidebar: false | SidebarEnum.Versioning | SidebarEnum.Comments;
  setActiveSidebar: (sidebar: false | SidebarEnum.Versioning | SidebarEnum.Comments) => void;
  onExportPdf?: () => void;
  onExportDocx?: () => void;
}

export function ActionButton({
  activeSidebar,
  setActiveSidebar,
  onExportPdf,
  onExportDocx,
}: ActionButtonProps): React.ReactNode {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>): void => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (): void => {
    setAnchorEl(null);
  };

  const showVersioningModal = React.useCallback(() => {
    setActiveSidebar(activeSidebar === SidebarEnum.Versioning ? false : SidebarEnum.Versioning);
  }, [activeSidebar]);

  const handleToggleComments = React.useCallback(() => {
    setActiveSidebar(activeSidebar === SidebarEnum.Comments ? false : SidebarEnum.Comments);
  }, [activeSidebar]);

  return (
    <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
      <>
        <IconButton onClick={handleOpen}>
          <MoreVert />
        </IconButton>
        <Popover
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          {onExportPdf && (
            <MenuItem
              onClick={() => {
                onExportPdf();
                handleClose();
              }}
            >
              Export as PDF
            </MenuItem>
          )}
          {onExportDocx && (
            <MenuItem
              onClick={() => {
                onExportDocx();
                handleClose();
              }}
            >
              Export as DOCX
            </MenuItem>
          )}
          {(onExportPdf || onExportDocx) && <Divider style={{ margin: "0px" }} />}
          <MenuItem
            id="versioning-button"
            onClick={() => {
              showVersioningModal();
              handleClose();
            }}
          >
            {activeSidebar === SidebarEnum.Versioning
              ? "Hide version history"
              : "Show version history"}
          </MenuItem>
          <MenuItem
            id="comments-button"
            onClick={() => {
              handleToggleComments();
              handleClose();
            }}
          >
            {activeSidebar === SidebarEnum.Comments ? "Hide comments" : "Show comments"}
          </MenuItem>
        </Popover>
      </>
    </Box>
  );
}
